// extracted by mini-css-extract-plugin
module.exports = {"firm":"FirmFundNames_firm__1PfTt","fund":"FirmFundNames_fund__3gX_8"};